import Image from "next/image";
const Footer = dynamic(() => import("../../components/Footer"), { ssr: false });
const Navbar = dynamic(() => import("../../components/Navbar"), { ssr: false });
import { useState } from "react";
import axios from "axios";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";

const DownloadResource = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    whitepaper_title: "Challenges Faced by Procurement Aggregators in India’s Hospitality Sector",
    whitepaper_url: "https://www.itmtb.com/blog/whitepaper/challenges-faced-by-procurement-aggregators-in-india-hospitality-sector",
  });
  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const router = useRouter();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.phone || !formData.company) {
      setMessage("Please fill in all fields");
      return;
    }

    setIsSubmitting(true);

    const payload = {
      name: `${formData.name}`,
      email: formData.email,
      phone: formData.phone,
      company: formData.company,
      whitepaper_title: formData.whitepaper_title,
      whitepaper_url: formData.whitepaper_url,
    };

    try {
      const res = await axios.post("https://iyezxg6psa.execute-api.ap-south-1.amazonaws.com/default/live_itmtb_whitepaper_prospect", payload);

      if (res.data) {
        await axios.post("https://650dkyt87l.execute-api.ap-south-1.amazonaws.com/default/live_itmtb_whitepaper_send_url", {
          name: payload.name,
          email: payload.email,
          whitepaper_url: payload.whitepaper_url,
          whitepaper_title: payload.whitepaper_title,
        });

        setMessage("Submitted successfully!");
        alert("Redirecting to White Paper...");

        router.push("/blog/whitepaper/challenges-faced-by-procurement-aggregators-in-india-hospitality-sector");
      } else {
        setMessage("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form: ", error);
      setMessage("Submission failed.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <section>
      <Navbar />
      <div className="mt-16 flex flex-col md:flex-row sm:px-20 ">
        <div className="text-gray-700 sm:w-1/2 p-6 sm:px-12">
          <div className="flex flex-col gap-6 w-full">
            <h1 className="sm:text-4xl text-3xl font-medium">Tech-Driven Solutions for Hospitality Procurement: Overcoming Vendor Challenges</h1>
            <h3 className="text-2xl font-normal">
              How procurement aggregators turn vendor relationships into strategic assets, achieving 98% fulfillment—even with India’s smallest suppliers?
            </h3>
            <hr className="md:block hidden" />
            <p className="text-lg font-light md:block hidden">
              While competitors explain stockouts to disappointed guests, elite hospitality leaders have transformed fragile supply chains into powerful
              competitive advantages amid India's crippling ₹10.7 lakh crore payment crisis.
            </p>
            <p className="text-lg font-light md:block hidden">
              This exclusive whitepaper unveils how innovative procurement aggregators achieve the impossible: 98% fulfillment from previously unreliable
              vendors.
              <br />
            </p>
            <p className="text-lg font-normal md:block hidden">Inside, discover:</p>
            <ol className="list-disc text-lg font-light ml-4 md:block hidden">
              <li>Taj's strategy ensures seafood year-round despite monsoons</li>
              <li>Zomato Hyperpure's zero-capital method for securing exceptional ingredients</li>
              <li>The payment timing shift that turns struggling vendors into loyal partners</li>
              <li>Marriott's proprietary system that virtually eliminates stockouts</li>
              <li>The contractual framework that revolutionizes small vendor compliance</li>
            </ol>
            <p className="text-lg font-light md:block hidden">
              As payment delays disrupt operations nationwide, this whitepaper offers a blueprint to move from reactive firefighting to strategic supply chain
              mastery.
            </p>
            <p className="text-lg font-light md:block hidden">
              The question isn't whether you'll face vendor defaults—it's whether you'll have systems to prevent them from affecting your customers.
            </p>
          </div>
        </div>
        <div className="sm:w-1/2 mt-10 border rounded-xl overflow-hidden max-h-fit bg-white">
          <Image
            src={"/blogImages/hero/alex-wong-l5Tzv1alcps-unsplash.webp"}
            width={600}
            height={300}
            className=""
            alt={"Future-Proof Your Hospitality Supply Chain"}
          />
          <form className="space-y-6 text-gray-700 px-12 my-12" onSubmit={handleSubmit}>
            <h1 className="text-2xl font-medium">Get Access to Complete White Paper</h1>
            <div>
              <label className="block font-normal">Full name*</label>
              <input
                type="text"
                name="name"
                className="w-full border p-2 rounded bg-white outline-none"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label className="block font-normal">Email*</label>
              <input
                type="email"
                name="email"
                className="w-full border p-2 rounded bg-white outline-none"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label className="block font-normal">Organization name*</label>
              <input
                type="text"
                name="company"
                className="w-full border p-2 rounded bg-white outline-none"
                value={formData.company}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label className="block font-normal">Phone number*</label>
              <input
                type="tel"
                name="phone"
                pattern="[0-9]{10}"
                className="w-full border p-2 rounded bg-white outline-none"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <p className="font-light text-sm mt-1">
                By submitting this form, you agree to the{" "}
                <Link href="/privacy_policy.html">
                  <span className="underline cursor-pointer">Privacy Policy</span>
                </Link>
              </p>
            </div>
            {/* /privacy_policy.html */}
            <div className="flex flex-col justify-end ">
              <button
                type="submit"
                className="px-4 py-2 bg-[#f1aa4e] text-white rounded hover:bg-[#f5a236] transition-all duration-300"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting" : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default DownloadResource;
